import type { CheckoutStatus } from '../api';

interface StatusBadgeProps {
  status: CheckoutStatus;
}

const LABELS: Record<CheckoutStatus, string> = {
  pending: 'Waiting',
  awaiting_payment: 'Awaiting payment',
  detected: 'Detected',
  settled: 'Confirmed',
  expired: 'Expired',
  cancelled: 'Cancelled',
};

export default function StatusBadge({ status }: StatusBadgeProps) {
  return <span className={`badge ${status}`}>{LABELS[status]}</span>;
}
